module.exports = __webpack_public_path__ + "static/media/depart.37369dc1.jpg";